import React, { useState, useRef, useEffect } from "react"
import { BookOpen } from "lucide-react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
import { ChartTotalHoldings } from '../../cataloging/views/chart_total_holdings'
import { ChartGrowthRate } from "../../cataloging/views/chart_growth_rate"
import { ChartServiceBranch } from "../../cataloging/views/chart_service_branch"
import { ChartHoldingCategoryDistribution } from "../../cataloging/views/chart_holding_category_distribution"
import { ChartBranchHoldingTrend } from "../../cataloging/views/chart_branch_holding_trend"
import { TableHoldingTotal } from "../../cataloging/views/table_holding_total"

import dayjs from 'dayjs';
import { BadgeInfo } from 'lucide-react';
import { ChartCirculationStatscard } from "./chart_circulation_statscard"
import { ChartDailyCirculationTrend } from "./chart_daily_circulation_trend"
import { ChartTimeSlotCirculationDistribution } from "./chart_time_slot_circulation_distribution"
import { TableCirculationReportDetails } from "./table_circulation_report_details"
const basicFilterSetting = ["branchcode", 'itemtype']

const DailyCirculationStatistics = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
        keyword: null
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <BookOpen className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        每日流通統計
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >

                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                圖書借閱、歸還、續借的每日統計數據
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/checkout/total"
                        propsLabel="總借閱量"
                        rowKey="last_week_total"
                    />

                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/return/total"
                        propsLabel="總歸還量"
                        rowKey="last_week_total"
                        propsColor="#f09a45"
                    />
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/renew/total"
                        propsLabel="總續借量"
                        rowKey="this_week_renewals"

                    />
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/daily_average"
                        propsLabel="日均流通量"
                        rowKey="current_week_total"
                        propsColor="#f09a45"

                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"流通趨勢"}
                        extra={"日期區間內借閱、歸還統計"}
                    >
                        <ChartDailyCirculationTrend />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"時段流通分布"}
                        extra={"今日各時段的流通量分布"}
                    >
                        <ChartTimeSlotCirculationDistribution />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Card
                title={"流通統計報表"}
            >
                <TableCirculationReportDetails
                />
            </Card>
        </Col>

    </Row>)
}
export { DailyCirculationStatistics }